import store from '@/store'

export const isAssignorComplete = next => {
  store._actions['profile/fetch'][0]().then(() => {
    if (store.getters.current_user.user_type !== 'assignor_user' || (store.state.profile.current.assignor && (store.state.profile.current.assignor['complete?'] || store.state.profile.current.assignor['available_invoices?']))) {
      next()
    } else {
      next({name: 'steps.index'})
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/mixins/flux-control.js